import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Add ChecklistByUpc route override
 *
 * @namespace routes.ReportChecklistByItemFormAdd
 * @type {TmrRoute}
 */
let addRoute = {
  name: 'report.checklistsByItem.add',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.Checklist.edit`],
}

/**
 * Edit ChecklistByUpc route override
 *
 * @namespace routes.ReportChecklistByItemFormEdit
 * @type {TmrRoute}
 */
let editRoute = {
  name: 'report.checklistsByItem.view.edit',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.Checklist.edit`],
}

/**
 * Delete ChecklistByUpc route override
 *
 * @namespace routes.ReportChecklistByItemDelete
 * @type {TmrRoute}
 */
let deleteRoute = {
  name: 'report.checklistsByItem.view.delete',
  // Workaround for backend capability being different from frontend.
  accessControl: ['Resource.edit', `Resource.Checklist.edit`],
}

export const routes = [addRoute, editRoute, deleteRoute]

/**
 * Checklist add/edit form component.
 *
 * @type {ngComponent}
 */
export const tmrAdminChecklistByItemForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminChecklistByItemFormController',
  bindings: {
    resource: '<',
    toast: '<',
  },
}

/**
 * Controller of component {@link tmrAdminChecklistByItemForm}.
 *
 * @type {ngController}
 */
export class tmrAdminChecklistByItemFormController extends tmrResourceFormController {
  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    User,
    Item,
    TmrInvalidEpcError,
    Place,
    tmrChecklistOperationTypes
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, {
      User,
      Item,
      TmrInvalidEpcError,
      Place,
      tmrChecklistOperationTypes,
    })
  }

  $onInit() {
    super.$onInit()
    if (this.resource.items) this.epcs = this.resource.items.map(i => i.epc)
    else {
      this.epcs = []
      this.resource.items = []
    }
    this.resource.type = 'ChecklistByItemDto'
  }

  onEpcAdded(epc) {
    this.Item.decode({ epc })
      .$promise.then(item => {
        if (item.id) this.resource.items.push(item)
        else throw new this.TmrInvalidEpcError()
      })
      .catch(err => {
        this.epcs = this.epcs.filter(e => e !== epc)
        return this.TmrToast.exception(err)
      })
  }

  onEpcRemoved(epc) {
    this.resource.items = this.resource.items.filter(item => item.epc !== epc)
    this.epcs = this.epcs.filter(e => e !== epc)
  }

  /** Query to get places for md-autocomplete */
  getPlaces(value) {
    return this.Place.search({ value }).$promise
  }
}
